import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next/';
import { observer } from 'mobx-react-lite';

import styles from './MyVisitedPage.module.scss';
import { useStores } from '@models/RootStore/RootStore';
import ListWrapper from '@components/containers/ListWrapper/ListWrapper';
import { Meta } from '@components/layout/Meta/Meta';
import Spinner from '@components/ui/Spinner/Spinner';
import VisitedListItem from '@components/ui/VisitedListItem/VisitedListItem';
import { IMyVisitedPublicationFields } from 'modules/MyVisitedModule';
interface Props {
  fields: IMyVisitedPublicationFields;
  className?: string;
}

const MyVisitedPage = ({ className, fields }: Props) => {
  const { t } = useTranslation();
  const { UserStore } = useStores();

  const renderLoader = () => {
    return <Spinner color="#ff7546" />;
  };

  const renderList = () => {
    return UserStore.visitedTips.length > 0 ? (
      UserStore.visitedTips.map((tip) => {
        return <VisitedListItem className={styles.ListItem} key={tip.id} tip={tip} />;
      })
    ) : (
      <div className="h4">{t('DOMAIN.ACCOUNT.NO_VISITED_ITEMS')}</div>
    );
  };

  return (
    <>
      <Meta title={fields.meta_title || fields.title} description={fields.meta_description || ''} />
      <div className={cn(styles.MyVisitedPage, className)}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ListWrapper
                title={fields.title}
                icon={require('@assets/images/icons/heart.svg')}
                size="lg"
                titleType="h1">
                {UserStore.isLoading ? renderLoader() : renderList()}
              </ListWrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(MyVisitedPage);
